import React, { useState, useEffect } from 'react';
import './Noticias.css';

// Importar imágenes de noticias
// ⚠️ Agregar los archivos en src/assets/noticias/
import noticia1 from '../../assets/noticias/noticia1.jpg';
//import noticia2 from '../../assets/noticias/noticia2.jpg';
import noticia3 from '../../assets/noticias/noticia3.jpg';
import noticia4 from '../../assets/noticias/noticia4.jpg';
import noticia5 from '../../assets/noticias/noticia5.jpeg';
import noticia6 from '../../assets/noticias/noticia6.jpg';

const Noticias = () => {
  const [modalAbierto, setModalAbierto] = useState(false);
  const [noticiaSeleccionada, setNoticiaSeleccionada] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);

  const noticias = [
    {
      id: 1,
      titulo: 'Salud Mental en el Deporte',
      descripcion:
        'El reciente testimonio del futbolista argentino Matías Cano, ex capitán de Coquimbo Unido, volvió a poner en el centro la importancia de la salud mental en el deporte. El arquero compartió públicamente que atraviesa un complejo momento personal y que, por primera vez en su vida, experimentó pensamientos suicidas, haciendo además un llamado directo a su entorno para recibir apoyo y ayuda. En su mensaje, el deportista destacó la relevancia de reconocer las señales de alerta y buscar acompañamiento, enfatizando que no puede enfrentar la situación solo y que necesita el apoyo de su círculo cercano. Este acto de visibilización generó preocupación en el mundo deportivo, pero también abrió un espacio para reflexionar sobre la presión emocional que viven muchos atletas, incluso aquellos considerados referentes dentro de sus equipos. Desde la psicología deportiva, este caso invita a reforzar la importancia de hablar abiertamente sobre el bienestar emocional, normalizar la búsqueda de ayuda profesional y fomentar entornos deportivos donde la salud mental sea considerada tan relevante como el rendimiento físico. Reconocer las dificultades a tiempo y contar con redes de apoyo puede marcar la diferencia en la vida personal y deportiva de los atletas. Mensaje clave para la comunidad deportiva: Hablar, pedir ayuda y acompañar son acciones fundamentales para construir entornos deportivos más saludables, donde el bienestar emocional sea parte esencial del desarrollo y del rendimiento.',
      imagen: noticia1,
      fecha: '2026-04-01',
    }, 

    {
      id: 3,
      titulo: 'ANSIEDAD - ATENCIÓN',
      descripcion: 'En las disciplinas que  vemos en el día a día como psicólogos, notamos ciertas  posturas e inseguridades que tienen nuestros deportistas a la hora de competir o bien en sus entrenamientos. Parte de ellas es llevar mejor los aspectos de ansiedad y atención para mejorar el rendimiento de sí mismo. La ansiedad es una respuesta natural del cuerpo ante situaciones percibidas como amenazantes o estresantes. Aunque es normal sentir ansiedad en ciertas situaciones, como antes de una prueba importante o una entrevista de trabajo, la ansiedad excesiva o crónica puede ser un problema que afecte la calidad de vida y el bienestar emocional de una persona. Los síntomas de la ansiedad pueden incluir preocupación excesiva, nerviosismo, tensión muscular, dificultad para concentrarse. La atención psicológica para la ansiedad puede implicar terapia cognitivo-conductual (TCC), que ayuda a identificar y cambiar patrones de pensamiento y comportamiento que contribuyen a la ansiedad. También se pueden utilizar técnicas de relajación, como la respiración profunda o la meditación, para reducir los síntomas de ansiedad. La atención psicológica también puede incluir el desarrollo de estrategias de afrontamiento para manejar situaciones estresantes, así como el fomento de un estilo de vida saludable que incluya ejercicio regular, una dieta equilibrada y suficiente descanso. “EL ESFUERZO ES LA MAGIA QUE TRANSFORMA LOS EXITOS EN REALIDAD” POR CRISTOBAL MANSILLA',
      imagen: noticia3,
      fecha: '2022-03-03',
    },
    {
      id: 4,
      titulo: 'QUE PUEDEN HACER LOS PADRES',
      descripcion: 'Una herramienta sencilla y poderosa que puede marcar la diferencia en la confianza de los jóvenes deportistas es el "Diario de Logros", una estrategia de la psicología deportiva que invita a los atletas a reconocer sus propios avances, más allá del resultado. ¿En qué consiste? Al finalizar la jornada (entrenamiento o partido), el deportista escribe o comparte verbalmente 3 cosas que hizo bien. Pueden ser técnicas, tácticas o incluso actitudes positivas. Beneficios comprobados: Estudios del Journal of Sport Behavior indican que reforzar logros concretos mejora la autoconfianza en un 29% en deportistas jóvenes, especialmente cuando el entorno familiar refuerza este enfoque positivo. Esta estrategia ayuda a cambiar el foco del error al aprendizaje, fortaleciendo la motivación interna y la autoestima deportiva. ¿Que pueden hacer los padres? Incentivar esta práctica con preguntas como: “¿Qué te salió bien hoy?” “¿De qué te sentiste orgulloso?” “¿Qué aprendiste en la cancha?”',
      imagen: noticia4,
      fecha: '2022-04-04',
    },
    {
      id: 5,
      titulo: 'VIAJE A LA  TIERRA DEL FUEGO',
      descripcion: 'Visitar distintas instituciones, academias y escuelas no es solo parte de nuestro trabajo, es la oportunidad de dejar huellas que impacten en el desarrollo de nuevas generaciones. En conjunto con la academia Adarma, estuvimos en Punta Arenas compartiendo con distintas universidades y participando en espacios radiales, donde pudimos confirmar algo muy importante: la necesidad del acompañamiento deportivo está presente en todo Chile. Este viaje no solo fue una experiencia profesional, sino también una oportunidad para seguir concientizando sobre la importancia de la salud mental en el deporte y el impacto que tiene en el desarrollo de cada deportista. Queremos agradecer a cada uno de ustedes por confiar en nosotros, no solo para mejorar el rendimiento deportivo de sus hijos, sino también por ser parte en la formación de mejores personas. Como psicología deportiva, seguimos trabajando e incorporando nuevas herramientas que nos permitan entregar un servicio cada vez más completo, cercano y de alto nivel. Seguimos avanzando, con un propósito claro: acompañar, formar y potenciar.',
      imagen: noticia5,
      fecha: '2022-05-05',
    },

    {
      id: 6,
      titulo: 'CÓMO MANEJAR LAS EMOCIONES',
      descripcion: 'FACTOR 1: IDENTIFICACION DE LAS EMOCIONES ¿Qué es lo que me pasa? ¿Por qué me siento así? Son preguntas que normalmente le hacemos a nuestros deportistas para que ellos puedan definir sus emociones, a su vez, les damos un feedback de las mismas que como psicólogos identificamos. Las emociones suelen ir acompañadas de cambios físicos en el cuerpo. Por ejemplo, la ansiedad puede manifestarse con taquicardia, sudoración o tensión muscular, mientras que la tristeza puede sentirse como un peso en el pecho o lágrimas en los ojos.. Es por eso que es muy importante, antes de cualquier toma de decisión o determinación, saber identificarlas para saber cómo abordar dichas emociones. Parte de ello está el lenguaje verbal como no verbal, donde también podemos determinar factores a mejorar en el deportistas al momento de entrenar o en momentos de competencias. FACTOR 2: QUÉ HERRAMIENTAS OCUPO CON LAS EMOCIONES La respiración profunda y consciente puede ayudar a reducir el estrés y a calmar las emociones intensas. Tomarse unos minutos para respirar profundamente y centrarse en la respiración puede ser una forma efectiva de controlar las emociones. Imaginar imágenes o situaciones que te traigan calma y tranquilidad puede ayudar a reducir la intensidad de las emociones negativas. Por ejemplo, puedes visualizar un lugar tranquilo y relajante, como una playa o un bosque. Mindfulness: Esta técnica implica prestar atención consciente al momento presente, sin juzgar los pensamientos o emociones que surgen. El mindfulness puede ayudar a aumentar la conciencia emocional y a manejar las emociones de manera más efectiva. FACTOR 3: VISUALIZAR UN MEJOR ESCENARIO Piensa en una situación específica en la que te gustaría tener un mejor desempeño o en la que te sientas ansioso. Puede ser un entrenamiento, una final o el primer enfrentamiento contra tu rival. Cierra los ojos y visualiza la situación como si todo saliera perfectamente. Imagina cada detalle: cómo te sientes, cómo te ves, cómo suena el entorno, cómo reaccionan los demás. Trata de hacer la visualización lo más vívida y realista posible. Por ultimo, previo a competir, les pido que se relajen, escuchen música, en un espacio donde a ellos les acomode. Meditación para bajar los nervios y ansiedad.',
      imagen: noticia6,
      fecha: '2021-06-06',
    },
  ];

  // Últimas 3 noticias (mayor ID) para el carrusel destacado
  const noticiasDestacadas = [...noticias]
    .sort((a, b) => b.id - a.id)
    .slice(0, 3);

  // Carrusel automático
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % noticiasDestacadas.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [noticiasDestacadas.length]);

  const abrirModal = (noticia) => {
    setNoticiaSeleccionada(noticia);
    setModalAbierto(true);
    document.body.style.overflow = 'hidden';
  };

  const cerrarModal = () => {
    setModalAbierto(false);
    setNoticiaSeleccionada(null);
    document.body.style.overflow = 'auto';
  };

  const goToSlide = (index) => setCurrentSlide(index);
  const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % noticiasDestacadas.length);
  const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + noticiasDestacadas.length) % noticiasDestacadas.length);

  const formatFecha = (fecha) =>
    new Date(fecha).toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });

  return (
    <div className="noticias-container">

      {/* ── HEADER ── */}
      <div className="noticias-header">
        <h1 className="noticias-title">Noticias</h1>
        <p className="noticias-subtitle">Últimas novedades de MG Profesionales</p>
      </div>

      {/* ── CARRUSEL DESTACADAS ── */}
      <section className="noticias-carousel-section">
        <div className="section-container">
          <h2 className="carousel-section-title">Últimas Noticias</h2>
          <div className="noticias-carousel-container">
            {noticiasDestacadas.map((noticia, index) => (
              <div
                key={noticia.id}
                className={`carousel-noticia-slide ${index === currentSlide ? 'active' : ''}`}
                style={{ backgroundImage: `url(${noticia.imagen})` }}
              >
                <div className="carousel-noticia-overlay" />
                <div className="carousel-noticia-content">
                  <p className="carousel-noticia-fecha">{formatFecha(noticia.fecha)}</p>
                  <h3 className="carousel-noticia-titulo">{noticia.titulo}</h3>
                  <button
                    className="carousel-noticia-btn"
                    onClick={() => abrirModal(noticia)}
                  >
                    Leer más
                  </button>
                </div>
              </div>
            ))}

            <button className="carousel-noticia-button prev" onClick={prevSlide}>‹</button>
            <button className="carousel-noticia-button next" onClick={nextSlide}>›</button>

            <div className="carousel-noticia-indicators">
              {noticiasDestacadas.map((_, index) => (
                <button
                  key={index}
                  className={`carousel-indicator ${index === currentSlide ? 'active' : ''}`}
                  onClick={() => goToSlide(index)}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── SEPARADOR ── */}
      <div className="noticias-separator">
        <h2 className="separator-title">Todas las Noticias</h2>
      </div>

      {/* ── GRID DE NOTICIAS ── */}
      <div className="noticias-grid">
        {[...noticias]
          .sort((a, b) => b.id - a.id)
          .map((noticia) => (
            <div key={noticia.id} className="noticia-card">
              <div
                className="noticia-imagen"
                onClick={() => abrirModal(noticia)}
              >
                <img src={noticia.imagen} alt={noticia.titulo} />
                <div className="imagen-overlay">
                  <span className="ver-mas">Click para leer más</span>
                </div>
              </div>
              <div className="noticia-content">
                <p className="noticia-fecha">{formatFecha(noticia.fecha)}</p>
                <h3 className="noticia-titulo">{noticia.titulo}</h3>
              </div>
            </div>
          ))}
      </div>

      {/* ── MODAL ── */}
      {modalAbierto && noticiaSeleccionada && (
        <div className="modal-overlay" onClick={cerrarModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={cerrarModal}>×</button>

            <div className="modal-imagen">
              <img src={noticiaSeleccionada.imagen} alt={noticiaSeleccionada.titulo} />
            </div>

            <div className="modal-body">
              <p className="modal-fecha">{formatFecha(noticiaSeleccionada.fecha)}</p>
              <h2 className="modal-titulo">{noticiaSeleccionada.titulo}</h2>
              <p className="modal-descripcion">{noticiaSeleccionada.descripcion}</p>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Noticias;